import React from 'react';
import styles from './appLoginPreview.module.css';
import { LANDPAGE_APP_LOGIN_PREVIEW } from '../../landpage.constants';

const EmailInput: React.FC = () => (
  <input
    className={styles.input}
    type="email"
    placeholder={LANDPAGE_APP_LOGIN_PREVIEW.emailPlaceholder}
    disabled
    aria-disabled="true"
    readOnly
  />
);

const PasswordInput: React.FC = () => (
  <div className={styles.passwordField}>
    <input
      className={styles.input}
      type="password"
      placeholder={LANDPAGE_APP_LOGIN_PREVIEW.passwordPlaceholder}
      disabled
      aria-disabled="true"
      readOnly
    />
    <span className={styles.visibilityIcon} aria-hidden="true">
      <svg viewBox="0 0 24 24" focusable="false">
        <path
          fill="currentColor"
          d="M12 5c-5.5 0-9.7 4.1-11 7 1.3 2.9 5.5 7 11 7s9.7-4.1 11-7c-1.3-2.9-5.5-7-11-7zm0 11.5c-2.5 0-4.5-2-4.5-4.5S9.5 7.5 12 7.5s4.5 2 4.5 4.5-2 4.5-4.5 4.5zm0-7c-1.4 0-2.5 1.1-2.5 2.5S10.6 14.5 12 14.5s2.5-1.1 2.5-2.5S13.4 9.5 12 9.5z"
        />
      </svg>
    </span>
  </div>
);

const LoginButton: React.FC = () => (
  <button className={styles.loginButton} type="button" disabled aria-disabled="true">
    {LANDPAGE_APP_LOGIN_PREVIEW.loginButtonLabel}
  </button>
);

const AppLoginPreview: React.FC = () => (
  <div className={styles.preview}>
    <EmailInput />
    <PasswordInput />
    <LoginButton />
  </div>
);

export default AppLoginPreview;
